import { type Enum } from '@webapp/infrastructure/types/Enum'

// Report family: /api/v3/reports/orders/{dimension} (purchased_date_*) or
// /api/v3/reports/expenses/departments (expensed_date_*).
export const ReportKinds = {
  ORDERS: 'orders',
  EXPENSES: 'expenses',
} as const

export type ReportKind = Enum<typeof ReportKinds>
